import {createSlice} from '@reduxjs/toolkit';

export const ROLLOVER_MODE = process.env.REACT_APP_ROLLOVER_MODE;

export const esoySlice = createSlice({
  name: 'esoy',
  initialState: {
    rolloverSegment: 'pre',
  },
  reducers: {
    setRolloverSegment(state, action) {
      state.rolloverSegment = action.payload;
    },
  },
});

export const {setRolloverSegment} = esoySlice.actions;

export const selectRolloverSegment = (state) => state.esoy.rolloverSegment;

export const selectEffectiveRolloverMode = (state) =>
  ROLLOVER_MODE === 'showall' ? state.esoy.rolloverSegment : ROLLOVER_MODE;
